<div class="container">
  <div class="icon">
    <ng-content></ng-content>
  </div>

  <span class="label">{{ label }}</span>
  <span class="value">{{ value }}</span>
</div>
